import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Sparkles, ArrowRight } from "lucide-react";
import { nextSabbat, fmtDate } from "@/lib/moon";
import { SABBAT_INFO } from "@/lib/sabbats";

export const SabbatBanner = () => {
  const { lang, t } = useLang();
  const now = new Date();
  const s = nextSabbat(now);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.round((s.date - today) / 86400000);
  const info = SABBAT_INFO[s.key];

  return (
    <Link to="/lune" data-testid="sabbat-banner" className="group block bg-gradient-to-r from-amber-950/40 via-[#121418] to-[#121418] border-y border-amber-900/30 hover:border-amber-700/50 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
        <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-500 shrink-0"><Sparkles className="w-4 h-4" /> {t("sabbat_spotlight")}</span>
        <div className="flex-1 min-w-0">
          <span className="font-serif text-xl text-amber-100">{t(`sabbat_${s.key}`)}</span>
          <span className="text-stone-500 text-sm ml-2">· {fmtDate(s.date, lang)} · {days === 0 ? t("lunar_today") : `${days} ${days === 1 ? t("sabbat_day") : t("sabbat_days")}`}</span>
          {info && <p className="text-sm text-stone-400 truncate">{info.ritual[lang]}</p>}
        </div>
        <span className="inline-flex items-center gap-1.5 text-sm text-amber-400 group-hover:text-amber-300 font-mono shrink-0">{t("sabbat_cta")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
      </div>
    </Link>
  );
};

export default SabbatBanner;
